import React from 'react';
import { useIntl } from 'react-intl';
import { faEye } from '@fortawesome/pro-light-svg-icons/faEye';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../common/views/SMLButton/SMLButton';
import { editorMessages } from './editorMessages';
import { EditorStatus } from './topBar/editorStatus';
import { EditorPublish } from './topBar/useEditorPublish';
import { SMLEditorPublishButton } from './topBar/SMLEditorPublishButton';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for several parts; each part uses its own slice of it */
import styles from './SMLEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SMLEditorPhoneBarProps {
  accountId: number;
  status: EditorStatus;
  blockCount: number;
  publish: EditorPublish;
  onPreview: () => void;
}

/** Below 992 px the bottom bar holds Preview and Publish (design a8). */
const SMLEditorPhoneBarComponent: React.FC<SMLEditorPhoneBarProps> = ({
  accountId,
  status,
  blockCount,
  publish,
  onPreview,
}) => {
  const intl = useIntl();
  return (
    <div className={styles.phoneBar}>
      <SMLButton outline leftIcon={faEye} onClick={onPreview} stretch omitCap>
        {intl.formatMessage(editorMessages.preview)}
      </SMLButton>
      <SMLEditorPublishButton accountId={accountId} status={status} blockCount={blockCount} publish={publish} stretch />
    </div>
  );
};

export const SMLEditorPhoneBar = TypedMemo(SMLEditorPhoneBarComponent);
